module.exports = __webpack_public_path__ + "static/media/menu_dashboard.0889225b.png";